import { useState, useCallback } from 'react'
import { authService } from '../../../../../services/authService'
import type { UserInfo } from '../types'
import companyService from '../../../../../services/companyService'
import majorityShareholderService from '../../../../../services/majorityShareholderService'

export const useUserData = () => {
  const [userInfo, setUserInfo] = useState<UserInfo>({
    email: '',
    name: '',
    phone: '',
    userId: '',
    primaryAddress: '',
  })
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const getPersonTypeFromStorage = () => {
    try {
      const userData = localStorage.getItem('user_data')
      if (userData) {
        const user = JSON.parse(userData)
        return user.personType
      }
      return null
    } catch (error) {
      console.error('Error al obtener personType:', error)
      return null
    }
  }

  const personTypeStorage = getPersonTypeFromStorage()

  const loadUserData = useCallback(async () => {
    setIsLoading(true)
    setError(null)

    try {
      const user = authService.getUser()
      if (!user) {
        throw new Error('Usuario no autenticado')
      }

      const updatedUserInfo: UserInfo = {
        email: user.email,
        userId: user.id,
        name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
        phone: user.phone || '',
        primaryAddress: '',
      }

      // First, try to get company address from company data
      if (personTypeStorage === 'PM') {
        try {
          const newUserInfo = await companyService.getCompanyCalendlyInfo()
          console.log('📦 newUserInfo PM:', newUserInfo)

          setUserInfo(newUserInfo)
          return
        } catch (error) {
          console.error('Error al obtener información de la empresa:', error)
        }
      } else {
        try {
          const newUserInfo =
            await majorityShareholderService.getShareholderCalendlyInfo()
          console.log('📦 newUserInfo PF:', newUserInfo)

          if (newUserInfo) {
            updatedUserInfo.email = newUserInfo.email
            updatedUserInfo.name = newUserInfo.name
            updatedUserInfo.phone = newUserInfo.phone
            updatedUserInfo.primaryAddress = newUserInfo.primaryAddress
            setUserInfo(updatedUserInfo)
            return
          }
        } catch (error) {
          console.error('Error al obtener información de la empresa:', error)
        }
      }

      // Default address if none found
      if (!updatedUserInfo.primaryAddress) {
        updatedUserInfo.primaryAddress = 'México'
      }

      setUserInfo(updatedUserInfo)
    } catch (error: any) {
      console.error('Error loading user data:', error)
      setError(error.message)
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    userInfo,
    isLoading,
    error,
    loadUserData,
    setError,
  }
}
